import axios from 'axios'

import { config } from './config'

export { DocumentsHttp } from './api/documents-http'
export { PaymentsHttp } from './api/payments-http'
export { CustomersHttp } from './api/customers-http'
export { SystemUsersHttp } from './api/system-users-http'
export { AppDataHttp } from './api/app-data-http'

export const AuthHttp = axios.create({
  timeout: 9000000,
  baseURL: config.api.auth.baseUrl
})

